import { render } from "./TerminationPolicyModal.vue?vue&type=template&id=7761df95"
import script from "./TerminationPolicyModal.vue?vue&type=script&lang=js"
export * from "./TerminationPolicyModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__